import { render, staticRenderFns } from "./BannerHasNoIvaDays.vue?vue&type=template&id=06510d6a&scoped=true"
import script from "./BannerHasNoIvaDays.vue?vue&type=script&lang=js"
export * from "./BannerHasNoIvaDays.vue?vue&type=script&lang=js"
import style0 from "./BannerHasNoIvaDays.vue?vue&type=style&index=0&id=06510d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06510d6a",
  null
  
)

export default component.exports